import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getLocationBill = params => {
  return axios.request({
    url: "/finance/location/bill",
    method: "get",
    params
  });
};
export const getDetails = params => {
  return axios.request({
    url: `/finance/location/bill/${params.id}`,
    method: "get",
    params
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/location/bill/${data.id}`,
    method: "put",
    data
  });
};

export const confirmBill = data => {
  return axios.request({
    url: `/finance/location/bill/confirm/${data.id}`,
    method: "post",
    data
  });
};
export const writeOffBill = data => {
  return axios.request({
    url: `/finance/location/bill/writeOff/${data.id}`,
    method: "post",
    data
  });
};

export const delItem = data => {
  return axios.request({
    url: `/finance/location/bill/${data.id}`,
    method: "delete",
    data
  });
};
